import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=9b6c8c02&scoped=true"
import script from "./CCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CCheckbox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CCheckbox.vue?vue&type=style&index=0&id=9b6c8c02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6c8c02",
  null
  
)

export default component.exports